export default function Filter() {
	let newsFilters = document.querySelectorAll('.js-filters')

	if (!newsFilters.length) return

	newsFilters.forEach((filter) => {
		filter.addEventListener('change', () => {
			filter.closest('form').submit()
		})
	})
}
